// 세금계산서 중요 알림 컴포넌트

import { FileText } from 'lucide-react';
import type { InvoiceTranslations } from './types';

interface InvoiceNoticeProps {
  translations: InvoiceTranslations;
}

export function InvoiceNotice({ translations }: InvoiceNoticeProps) {
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
      <div className="flex items-start gap-2">
        <FileText className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="font-medium text-blue-900 dark:text-blue-200 mb-1">
            {translations.important}
          </h4>
          <p className="text-sm text-blue-800 dark:text-blue-300">{translations.keepRecord}</p>
        </div>
      </div>
    </div>
  );
}
